import { gql } from '@apollo/client';
import { ResumeEducationCustomFields } from '~/jobiqo/components/Slots/ResumeEducationCustomFields';
import { ResumeWorkXPCustomFields } from '~/jobiqo/components/Slots/ResumeWorkXPCustomFields';
import { ResumeFrontendFeatureFlags } from '~/jobiqo/components/Resume/graphql/resumeFeatureFlags';

export function getResumeFragment(
  currentOrganizationId: null | number = null,
  bookmarkEnabled,
  frontendFlags: ResumeFrontendFeatureFlags = {},
) {
  const RESUME_BADGES_ACTIVE = frontendFlags.RESUME_BADGES_ACTIVE;
  const SEASONAL_JOBS_ENABLED = frontendFlags.SEASONAL_JOBS_ENABLED;
  const FIELDS_OF_STUDY_FEATURE_ACTIVE =
    frontendFlags.FIELDS_OF_STUDY_FEATURE_ACTIVE;
  const RESUME_EDUCATION_CUSTOM_FIELDS = ResumeEducationCustomFields();
  const RESUME_WORK_XP_CUSTOM_FIELDS = ResumeWorkXPCustomFields();

  return gql`
      fragment ResumeFragment on Resume {
          id
          user {
              id
              firstName
              lastName
              displayName
          }
          privateFieldsAccess(organizationId: ${currentOrganizationId})
          title
          homeLocation
          availableStart
          birthday
          picture(style: "thumbnail") {
              url
          }
          email
          firstName
          lastName
          careerStatus {
              tid
              label
          }
          desiredOccupation {
              tid
              label
              parent {
                tid
                label
              }
          }
          desiredLocation
          desiredSalary {
              tid
              label
          }
          education {
              id
              degreeLevel {
                  tid
                  label
              }
              institution
              studyProgram
              summary
              location
              timePeriod {
                  startDate
                  endDate
                  untilNow
              }
              ${
                FIELDS_OF_STUDY_FEATURE_ACTIVE
                  ? `fieldOfStudy {
                tid
                label
              }`
                  : ''
              }
              ${RESUME_EDUCATION_CUSTOM_FIELDS}
          }
          workXP {
              id
              companyName
              jobTitle
              employmentType {
                  tid
                  label
              }
              occupation {
                  tid
                  label
              }
              location
              timePeriod {
                  startDate
                  endDate
                  untilNow
              }
              summary
              ${RESUME_WORK_XP_CUSTOM_FIELDS}
          }
          employmentType {
              tid
              label
          }
          languages {
              level
              label
              term {
                  tid
                  label
              }
          }
          languageNotes
          phone
          resumeState {
              key
              value
          }
          salutation
          skills {
              level
              label
              term {
                  tid
                  label
              }
          }
          skillsNotes
          about
          attachments {
              id
              url
              fileName
              isCv
          }
          hasAttachment
          created
          changed
          completeness {
              completed
              currentPercent
              incomplete
              nextFieldLabel
              nextFieldName
              nextPercent
              total
          }
          academicPrefix
          academicPostfix
          ${bookmarkEnabled ? `bookmarked` : ''}
          ${
            SEASONAL_JOBS_ENABLED
              ? `
            availabilityPeriods {
              startDate
              endDate
            }
          `
              : ''
          }
          ${
            RESUME_BADGES_ACTIVE
              ? `
            badges {
                id
                name
                description
                icon(style: "thumbnail") {
                  url
                  alt
                }
              }
            `
              : ''
          }
      }
  `;
}

export default getResumeFragment;
